import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import { getShortDescription, getLongDescription } from '@/utils/innerHtmlUtils';
import { getCategImage, getCategImageWebp } from '@/utils/categUtils';
import { useServices } from '@/services/useServices';
import { NS } from '@/constants';

import styles from './CategCard.module.scss';

export const CategCard = ({ categ, isMobile, seeDescription }) => {
  const { datalayerService } = useServices();
  const { t } = useTranslation(NS.COMMON);
  const { name, longDescription, image } = categ;
  const desktopDescription = getLongDescription(longDescription || '');
  const mobileDescription = getShortDescription(longDescription || '');
  const imageUrl = getCategImage(image);
  const clickMore = () => {
    datalayerService.pushData('event', 'seeMoreListing');
    seeDescription();
  };

  return (
    <div className={styles.background} data-test-id="background">
      {!isMobile && (
        <picture className={styles.image}>
          <source srcSet={getCategImageWebp(image)} type="image/webp"/>
          <source srcSet={imageUrl} type="image/jpeg"/>
          <img
            src={imageUrl}
            alt={t('btn.showMore')}
            style={{ maxWidth: '100%', height: '100%' }}
            loading="eager"
            fetchPriority="high"
            data-test-id="background-image"
          />
        </picture>
      )}

      {isMobile && (
        <div className={styles.mobileFallback} />
      )}

      <div className={styles.content}>
        {name && (
          <h1 className={styles.title} data-test-id="title" dangerouslySetInnerHTML={{ __html: name }} />
        )}
        {longDescription && (
          <p className={styles.description} data-test-id="description">
            <span dangerouslySetInnerHTML={{ __html: isMobile ? mobileDescription : desktopDescription }} />
            <a className={styles['see-more']}
              data-toggle="modal"
              data-target=".long-description-modal-lg"
              data-test-id="see-more"
              onClick={clickMore}>
              {t('btn.showMore')}
            </a>
          </p>
        )}
      </div>
    </div>
  );
};

CategCard.propTypes = {
  categ: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
  seeDescription: PropTypes.func
};

export default CategCard;
